
import WidgetDefaultNuxt from '../default/nuxt.vue';

export default {
  name: 'WidgetTextNuxt',
  extends: WidgetDefaultNuxt,
  data() {
    let text = this.values.text;
    let fontText = this.getLocaleValue(text);
    return {
      widgetClassName: 'widget-text',
      text,
      fontText,
      localePath: [{ key: 'fontText', value: text }],
    };
  },
  methods: {
    initEvent() {
      this.rocketOn('rocket:system:update-text', true, (v) => {
        this.fontText = v;
        if (this.localePath.length) {
          this.localePath = [];
          this.updateLocalePathMap();
        }
      });
    },
  },
};
